import { PatchCulpritContactInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritContactInfo/patchCulpritContactInfoQuery.type';
import { patchCulpritContactInfoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritContactInfo/patchCulpritContactInfoQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchCulpritContactInfoQueryOptions = () =>
  useMutation({
    mutationKey: ['CulpritContactInfoQuery'],
    mutationFn: (params: PatchCulpritContactInfoQueryParamsType) =>
      patchCulpritContactInfoFunction(params),
  });
